import { defineComponent as o, h as i, Transition as e } from "vue";
import a from "./highrise635.mjs";
const m = o({
  name: "BaseIconSwitchTransition",
  setup(r, {
    slots: n
  }) {
    const t = a();
    return () => i(e, {
      name: "icon-switch-transition",
      appear: t.value
    }, n);
  }
});
export {
  m as default
};
